export default function findingUniqueReferenceNumberDirective(
  $q,
  $timeout,
  amDataService
) {
  return {
    restrict: 'A',
    require: '?ngModel',
    link,
  };

  function link(scope, element, attributes, ngModel) {
    $timeout(
      () => {
        const auditId = attributes.auditId || -1;
        const findingId = attributes.findingId || -1;

        ngModel.$asyncValidators.amFindingUniqueReferenceNumber = function (modelValue) {
          const defer = $q.defer();
          if (modelValue) {
            amDataService.checkFindingReferenceNumberExists(auditId, findingId, modelValue)
              .then((data) => {
                if (data && data.data.result === false) {
                  defer.resolve();
                } else {
                  defer.reject();
                }
              })
              .catch(defer.reject);
          } else {
            defer.resolve();
          }

          return defer.promise;
        };
      },
      0
    );
  }
}

export const name = 'amFindingUniqueReferenceNumber';

findingUniqueReferenceNumberDirective.$inject = [
  '$q',
  '$timeout',
  'amDataService'
];
